import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { WinThemesPanel } from '../../Outputs/WinThemesPanel';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
import { usePursuitOutputsWrite } from '../pursuitHooks';
/** Win themes: the Outputs win-themes panel on its own page. */ export function WinThemesSection() {
    const { captureProjectId, zouProjectId } = usePursuitRecord();
    // GRW-30: never writable on a merged stub or for a reader of the header.
    // GRW-30: sections always sit in the record shell, so the gate is the header capabilities.
    const { canEdit } = usePursuitRecord().capabilities;
    const canWrite = usePursuitOutputsWrite(captureProjectId, zouProjectId) && canEdit;
    const navigate = useNavigate();
    return /*#__PURE__*/ _jsx(PursuitSectionFrame, {
        title: "Win themes",
        children: /*#__PURE__*/ _jsx(WinThemesPanel, {
            canWrite: canWrite,
            onOpenCustomerThemes: ()=>navigate(`/capture/${captureProjectId}/customer/themes`),
            pursuitId: captureProjectId
        })
    });
}
